module.exports = __webpack_public_path__ + "img/answer.00fce9b4.png";